import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, Bike, CheckCircle2 } from 'lucide-react';
import { FadeUp } from './MotionReveals';

const C2R_URL = 'https://code2roues.fr/?utm_source=codevoiture&utm_medium=passerelle&utm_campaign=home';

export default function PasserelleMotoSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 lg:px-6 mt-14 sm:mt-24" data-testid="passerelle-moto-section">
      <FadeUp>
        <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl border border-sky-500/25 bg-gradient-to-br from-[#081020] via-[#070b14] to-[#0d0d0e] p-5 sm:p-8 lg:p-12">
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-sky-500/10 blur-3xl pointer-events-none" />
          <div className="grid lg:grid-cols-[1.4fr_1fr] gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-sky-400/30 bg-sky-500/10 text-sky-300 text-[10.5px] uppercase tracking-[0.22em] font-mono-spec font-bold mb-4">
                <Bike size={12} /> Notre plateforme sœur · 100 % gratuite
              </div>
              <h2 className="font-serif-editorial text-white text-[24px] sm:text-[32px] lg:text-[42px] leading-[1.05]">
                Tu prépares aussi le <span className="text-sky-300">permis moto</span> ?
              </h2>
              <p className="text-white/65 text-[13px] sm:text-[14.5px] mt-3 max-w-xl leading-relaxed">
                Même équipe ECSR, même ADN magazine — appliqué au 2 roues. BSR/AM dès 14 ans, A1, A2, passerelle A,
                formation 125 avec ton permis B : tout est sur <strong className="text-sky-300">Code2Roues.fr</strong>, sans pub, sans QCM à rallonge.
              </p>
              <ul className="mt-4 sm:mt-5 space-y-2 text-white/80 text-[12.5px] sm:text-[14px]">
                {['31 enquêtes magazine + 9 dossiers ETM', 'Plateau interactif : les 6 manœuvres officielles', 'Livret REMC moto · 38 compétences'].map((s, i) => (
                  <li key={i} className="flex items-center gap-2"><CheckCircle2 size={15} className="text-sky-400 shrink-0" /> {s}</li>
                ))}
              </ul>
              <div className="mt-5 sm:mt-7 flex flex-wrap gap-2 sm:gap-3">
                <a href={C2R_URL} target="_blank" rel="noopener noreferrer" data-testid="passerelle-moto-cta-c2r" className="h-11 px-5 rounded-full bg-sky-500 hover:bg-sky-400 text-black text-[13px] sm:text-[14px] font-semibold inline-flex items-center gap-2 shadow-lg shadow-sky-900/40 transition-colors">
                  Découvrir Code2Roues.fr <ExternalLink size={14} />
                </a>
                <Link to="/permis-125" data-testid="passerelle-moto-cta-125" className="h-11 px-5 rounded-full border border-white/15 text-white text-[13px] sm:text-[14px] font-medium hover:bg-white/5 inline-flex items-center gap-2 transition-colors">
                  Rouler en 125 avec le permis B <ArrowRight size={14} />
                </Link>
                <Link to="/livret-am/lecteur" data-testid="passerelle-livret-am" className="h-11 px-5 rounded-full border border-amber-500/40 text-amber-300 text-[13px] sm:text-[14px] font-medium hover:bg-amber-950/20 inline-flex items-center gap-2 transition-colors">
                  📖 Livret voiturette AM (Topolino)
                </Link>
              </div>
            </div>
            <div className="hidden lg:grid grid-cols-2 gap-3" aria-hidden="true">
              {[
                { k: 'AM · BSR', v: 'Dès 14 ans', d: 'Cyclomoteur 50 cc' },
                { k: 'A1', v: 'Dès 16 ans', d: '125 cc · 11 kW' },
                { k: 'A2', v: 'Dès 18 ans', d: '35 kW max' },
                { k: '125 (B)', v: 'Permis B + 2 ans', d: 'Formation 7 h' },
              ].map((c, i) => (
                <div key={i} className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
                  <div className="text-sky-300 font-mono-spec text-[11px] uppercase tracking-widest font-bold">{c.k}</div>
                  <div className="text-white text-[17px] font-serif-editorial mt-1">{c.v}</div>
                  <div className="text-white/50 text-[12px] mt-0.5">{c.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </FadeUp>
    </section>
  );
}
